export const pagesFleetsEn = {
  title: "Fleets",
  listTab: "Fleet List",
  list: {
    pageTitle: "Fleets",
    addFleet: "Add Fleet",
    filterPlaceholder: "Search fleet...",
    mainType: {
      all: "All",
      vehicle: "Vehicles",
      ship: "Ships",
      aircraft: "Aircraft",
    },
    tabs: {
      all: "All",
      available: "Available",
      inUse: "In Use",
      maintenance: "Maintenance",
      retired: "Retired",
    },
    table: {
      headers: {
        fleetId: "Fleet ID",
        fleetName: "Fleet Name",
        fleetType: "Type",
        fleetCategory: "Category",
        model: "Model",
        status: "Status",
        assignedPlace: "Assigned Place",
        assignedWorker: "Assigned Worker",
        createdAt: "Created At",
      },
    },
    filters: {
      fleetType: "Fleet Type",
      fleetCategory: "Fleet Category",
      assignedWorker: "Assigned Worker",
      placementPlace: "Placement Place",
      status: "Status",
    },
    status: {
      available: "Available",
      inUse: "In Use",
      maintenance: "Maintenance",
      retired: "Retired",
      disposed: "Disposed",
    },
  },
  detail: {
    pageTitle: "Fleet Detail",
    sections: {
      basicInfo: "Basic Information",
      vehicleDetails: "Vehicle Details",
      shipDetails: "Ship Details",
      aircraftDetails: "Aircraft Details",
      ownershipInfo: "Ownership & Contract",
      technicalSpecs: "Technical Specifications",
      dimensions: "Dimensions & Weight",
      gpsInfo: "GPS Information",
      insurance: "Insurance",
      drivers: "Driver Information",
      documents: "Documents",
      usageHistory: "Usage History",
      maintenanceHistory: "Maintenance History",
      // Fleet common categories
      fleetIdInformation: "Fleet ID Information",
      ownershipResponsibility: "Ownership & Responsibility",
      operationNavigation: "Operation & Navigation",
      maintenanceCompliance: "Maintenance & Compliance",
      // Ship specific categories
      shipIdInformation: "Ship ID Information",
      technicalSpecifications: "Technical Specifications",
      ownershipManagement: "Ownership / Management",
      operationNavigationInfo: "Operation / Navigation Information",
      operationNavigationShip: "Operation & Navigation",
      maintenanceComplianceShip: "Maintenance / Compliance",
      permitsLicenses: "Permits / Licenses",
      accessoriesAssets: "Accessories / Asset Management",
      accessoriesAssetTracking: "Accessories & Asset Tracking",
    },
    tabs: {
      basic: "Basic Info",
      vehicle: "Vehicle Details",
      insurance: "Insurance",
      drivers: "Drivers",
      usage: "Usage History",
      maintenance: "Maintenance History",
      documents: "Documents",
    },
    fields: {
      fleetId: "Fleet ID",
      fleetName: "Fleet Name",
      fleetType: "Type",
      fleetCategory: "Category",
      manufacturer: "Manufacturer",
      model: "Model",
      serialNumber: "Serial Number",
      yearOfManufacture: "Year of Manufacture",
      ownershipType: "Ownership Type",
      ownerName: "Owner Name",
      leaseCompany: "Lease Company",
      leaseContractId: "Lease Contract ID",
      ownerPurpose: "Ownership Purpose",
      usagePurpose: "Usage Purpose",
      status: "Status",
      remarks: "Remarks",
      vehicleId: "Vehicle ID",
      licensePlateNumber: "License Plate",
      vehicleDimensions: "Vehicle Dimensions",
      maximumPayload: "Maximum Payload",
      operationLog: "OperationLog",
      reservationStatus: "reservationStatus",
      vehicleCategory: "Vehicle Category",
      vin: "VIN",
      vehicleType: "Vehicle Type",
      vehicleColor: "Vehicle Color",
      registrationDate: "Registration Date",
      engineType: "Engine Type",
      fuelType: "Fuel Type",
      transmission: "Transmission",
      seatCapacity: "Seat Capacity",
      odometerReading: "Odometer Reading",
      inspectionExpiryDate: "Inspection Expiry Date",
      insurancePolicyNumber: "Insurance Policy Number",
      insuranceProvider: "Insurance Provider",
      insuranceStartDate: "Insurance Start Date",
      insuranceEndDate: "Insurance End Date",
      insuranceAnnualPremium: "Annual Premium",
      insuranceDeductible: "Deductible",
      driveType: "Drive Type",
      placeId: "Location",
      placeName: "Location Name",
      assignedDepartment: "Assigned Department",
      vehicleUsagePurposes: "Vehicle Usage Purposes",
      responsiblePerson: "Responsible Person",
      // GPS Information
      gpsTrackingData: "GPS Tracking",
      gpsCurrentPosition: "Current Position",
      gpsCurrentLat: "Current Latitude",
      gpsCurrentLng: "Current Longitude",
      // Dimensions & Weight
      dimensionLength: "Length (mm)",
      dimensionWidth: "Width (mm)",
      dimensionHeight: "Height (mm)",
      curbWeight: "Curb Weight (kg)",
      maxPayload: "Max Payload (kg)",
      // Engine & Fuel
      engineDisplacement: "Engine Displacement (cc)",
      fuelTankCapacity: "Fuel Tank Capacity (L)",
      fuelEfficiency: "Fuel Efficiency (km/L)",
      // Operation Info
      totalOperationHours: "Total Operation Hours",
      utilizationRate: "Utilization Rate",
      lastOperationDate: "Last Operation Date",
      // Insurance Details
      insuranceCoverage: "Coverage",
      optionalInsuranceStatus: "Optional Insurance",
      // Driver Information
      driverName: "Driver Name",
      driverUserId: " Driver ID",
      licenseNumber: "License Number",
      licenseType: "License Type",
      licenseExpiryDate: "License Expiry Date",
      licenseExpirationDate: "License Expiration Date",
      // Document Information
      documentType: "Document Type",
      documentName: "Document Name",
      description: "Description",
      uploadedBy: "Uploaded By",
      uploadedAt: "Uploaded At",
      expiryDate: "Expiry Date",
      // Usage History
      startDatetime: "Start Date/Time",
      endDatetime: "End Date/Time",
      startLocation: "Start Location",
      endLocation: "End Location",
      purpose: "Purpose",
      distanceTraveled: "Distance (km)",
      fuelUsed: "Fuel Used (L)",
      // Maintenance History
      maintenance: {
        id: "Maintenance ID",
        date: "Maintenance Date",
        type: "Maintenance Type",
        description: "Work Description",
        cost: "Maintenance Cost",
        provider: "Service Provider",
      },
      maintenanceId: "Maintenance ID",
      maintenanceDate: "Maintenance Date",
      maintenanceType: "Maintenance Type",
      maintenanceDescription: "Work Description",
      maintenanceProvider: "Service Provider",
      maintenanceCost: "Cost",
      nextMaintenanceDate: "Next Maintenance Date",
      // Ship detail fields
      shipId: "Ship ID",
      shipName: "Ship Name",
      imoNumber: "IMO Number",
      mmsiNumber: "MMSI Number",
      callSign: "Call Sign",
      flagState: "Flag State",
      classificationSociety: "Classification Society",
      shipType: "Ship Type",
      hullNumber: "Hull Number",
      builder: "Builder",
      buildDate: "Build Date",
      grossTonnage: "Gross Tonnage",
      deadweightTonnage: "Deadweight Tonnage",
      navigationArea: "Navigation Area",
      lengthOverall: "Length Overall",
      breadth: "Breadth",
      draft: "Draft",
      engineSpecs: "Engine Specs",
      propulsionType: "Propulsion Type",
      fuelCapacity: "Fuel Capacity",
      ballastCapacity: "Ballast Capacity",
      cargoGear: "Cargo Gear",
      crewCapacity: "Crew Capacity",
      passengerCapacity: "Passenger Capacity",
      managementCompany: "Management Company",
      operationalManagerId: "Operational Manager",
      department: "Department",
      operationDepartment: "Operation Department",
      homePort: "Home Port",
      lastDeparture: "Last Departure",
      lastArrival: "Last Arrival",
      voyageLog: "Voyage Log",
      totalVoyageHours: "Total Voyage Hours",
      totalVoyageDistance: "Total Voyage Distance",
      aisDataSummary: "AIS Information",
      aisData: "AIS Data",
      classCertificateExpiry: "Class Certificate Expiry",
      ismCertificateExpiry: "ISM Certificate",
      ispsCertificateExpiry: "ISPS Certificate",
      inspectionLog: "Inspection Log",
      maintenanceLog: "Maintenance Log",
      nextInspectionDate: "Next Inspection Date",
      insuranceInfo: "Insurance Info",
      accidentLog: "Accident Log",
      vesselLicense: "Vessel License",
      vesselLicenseExpiry: "Vessel License Expiry Date",
      radioLicense: "Radio License",
      radioLicenseExpiry: "Radio License Expiry Date",
      specialNavigationPermit: "Special Navigation Permit",
      emissionCertificates: "Emission Certificates",
      lifeboatCount: "Lifeboat Count",
      lifejacketCount: "Lifejacket Count",
      firefightingEquipment: "Firefighting Equipment",
      electronicDevices: "Electronic Devices",
      // Additional Ship specific fields
      shipOwner: "Ship Owner",
      manager: "Manager",
      operator: "Operator",
      charterer: "Charterer",
      technicalManager: "Technical Manager",
      crewingAgent: "Crewing Agent",
      classification: "Classification",
      insuranceAgent: "Insurance Agent",
      currentVoyageStatus: "Current Voyage Status",
      tradingArea: "Trading Area",
      lastMaintenanceDate: "Last Maintenance Date",
      nextDockingDate: "Next Docking Date",
      fishingLicense: "Fishing License",
      cargoPermit: "Cargo Permit",
      operatingPermit: "Operating Permit",
      liferaftCount: "Life Raft Count",
      navigationSystemType: "Navigation System Type",
      communicationEquipment: "Communication Equipment",
      anchorType: "Anchor Type",
      assetTag: "Asset Tag",
      // Additional missing fields
      cost: "Cost",
      ispsCertificate: "ISPS Certificate",
      ismCertificate: "ISM Certificate",
      operationalManager: "Operational Manager",
      // Additional missing fields
      berthingLocation: "Berthing Location",
      captain: "Captain",
      chiefEngineer: "Chief Engineer",
      insuranceCompany: "Insurance Company",
      insuranceExpiry: "Insurance Expiry",
      mortgageStatus: "Mortgage Status",
      acquisitionCost: "Acquisition Cost",
      acquisitionDate: "Acquisition Date",
      depreciationMethod: "Depreciation Method",
      bookValue: "Book Value",
    },
    ownershipTypes: {
      OWNED: "Owned",
      LEASED: "Leased",
      CHARTERED: "Chartered",
      RENTAL: "Rental",
      CAR_SHARE: "Car Share",
      OPERATIONAL_LEASE: "Operational Lease",
      FINANCE_LEASE: "Finance Lease",
      OTHER: "Other",
    },
    ownerPurposes: {
      COMMERCIAL_TRANSPORT: "Commercial Transport",
      BUSINESS_USE: "Business Use",
      INVESTIGATION: "Investigation",
      TRAINING: "Training",
      OTHER: "Other",
    },
    fuelTypes: {
      GASOLINE: "Gasoline",
      DIESEL: "Diesel",
      HFO: "Heavy Fuel Oil",
      MGO: "Marine Gas Oil",
      LNG: "Liquefied Natural Gas",
      LPG: "Liquefied Petroleum Gas",
      ELECTRIC: "Electric",
      HYBRID_GASOLINE: "Hybrid (Gasoline)",
      HYBRID_DIESEL: "Hybrid (Diesel)",
      HYDROGEN: "Hydrogen",
      JET_FUEL: "Jet Fuel",
      AVGAS: "Aviation Gasoline",
      BIOFUEL: "Biofuel",
    },
    vehicleBodyTypes: {
      SEDAN: "Sedan",
      SUV: "SUV",
      WAGON: "Wagon",
      HATCHBACK: "Hatchback",
      COUPE: "Coupe",
      MINIVAN: "Minivan",
      TRUCK: "Truck",
      VAN: "Van",
      BUS: "Bus",
      MICROBUS: "Microbus",
      PICKUP: "Pickup",
      MOTORCYCLE: "Motorcycle",
      FORKLIFT: "Forklift",
      SPECIAL_PURPOSE: "Special Purpose",
    },
    vehicleCategories: {
      SALES: "Sales Vehicle",
      DELIVERY: "Delivery Vehicle",
      EXECUTIVE: "Executive Vehicle",
      RENTAL: "Rental Car",
      SERVICE: "Service Vehicle",
      SHUTTLE: "Shuttle Vehicle",
      EMERGENCY: "Emergency Vehicle",
      CONSTRUCTION: "Construction Vehicle",
      AGRICULTURAL: "Agricultural Vehicle",
    },
    vehicleUsagePurposes: {
      COMMERCIAL_TRANSPORT: "Commercial Transport",
      PASSENGER_SERVICE: "Passenger Service",
      CARGO_TRANSPORT: "Cargo Transport",
      INVESTIGATION: "Investigation",
      TRAINING: "Training",
      EXECUTIVE: "Executive",
      SALES: "Sales",
      LOGISTICS: "Logistics",
      OTHER: "Other",
      COMMUTE: "Commute",
      EMERGENCY: "Emergency",
      MAINTENANCE_SUPPORT: "Maintenance Support",
    },
    driveTypes: {
      TWO_WD: "2WD",
      FOUR_WD: "4WD",
      AWD: "AWD",
      FR: "FR (Rear-Wheel Drive)",
      FF: "FF (Front-Wheel Drive)",
      MR: "MR (Mid-Engine)",
      RR: "RR (Rear-Engine)",
    },
    transmissionTypes: {
      AT: "Automatic",
      MT: "Manual",
      CVT: "CVT",
      DCT: "Dual Clutch",
      AMT: "AMT",
      ELECTRIC: "Electric (EV)",
    },
    repairStatuses: {
      REPAIRED: "Repaired",
      REPAIRING: "Under Repair",
      SCRAPPED: "Scrapped",
    },
    navigationAreas: {
      COASTAL: "Coastal",
      INTERNATIONAL: "International",
      PORT_LIMIT: "Port Limit",
      INLAND: "Inland",
      NEAR_COASTAL: "Near Coastal",
      OCEAN_GOING: "Ocean Going",
      SMOOTH_WATER: "Smooth Water",
    },
    propulsionTypes: {
      SCREW: "Screw Propeller",
      WATER_JET: "Water Jet",
      AZIMUTH: "Azimuth Thruster",
      PADDLE_WHEEL: "Paddle Wheel",
      SAIL: "Sail",
      POD: "Pod Propulsion",
      HYBRID: "Hybrid",
    },
    engineType: {
      gasoline: "Gasoline",
      diesel: "Diesel",
      electric: "Electric",
      hybrid: "Hybrid",
      phev: "Plug-in Hybrid",
      hydrogen: "Hydrogen",
    },
    engineTypes: {
      GASOLINE: "Gasoline",
      DIESEL: "Diesel",
      ELECTRIC: "Electric",
      HYBRID: "Hybrid",
      PLUGIN_HYBRID: "Plug-in Hybrid",
      HYDROGEN: "Hydrogen",
    },
    driveType: {
      twoWd: "2WD",
      fourWd: "4WD",
      awd: "AWD",
    },
    optionalInsuranceStatus: {
      insured: "Insured",
      not_insured: "Not Insured",
      processing: "Processing",
    },
    licenseTypes: {
      ordinary: "Ordinary",
      medium: "Medium",
      large: "Large",
    },
    reservationStatuses: {
      AVAILABLE: "Available",
      RESERVED: "Reserved",
      IN_USE: "In Use",
      MAINTENANCE: "Maintenance",
      CLEANING: "Cleaning",
      INSPECTION: "Inspection",
      NOT_AVAILABLE: "Not Available",
    },
    ownershipPurposes: {
      COMMERCIAL_TRANSPORT: "Commercial Transport",
      PASSENGER_SERVICE: "Passenger Service",
      CARGO_TRANSPORT: "Cargo Transport",
      INVESTIGATION: "Investigation",
      TRAINING: "Training",
      EXECUTIVE: "Executive",
      SALES: "Sales",
      LOGISTICS: "Logistics",
    },
    transmission: {
      at: "Automatic",
      mt: "Manual",
      cvt: "CVT",
      dct: "Dual Clutch",
    },
    vehicle: {
      noVehicleData: "No vehicle data available",
      categories: {
        "basic-information": "Basic Information",
        "vehicle-fleet-id": "Vehicle ID Information",
        "ownership-management": "Ownership & Management",
        "maintenance-management": "Maintenance Management",
        "ownership-information": "Ownership Information",
        "location-gps": "Location & GPS",
        "system-information": "System Information",
        "vehicle-id-information": "Vehicle ID Information",
        "technical-specifications": "Technical Specifications",
        "ownership-responsibility": "Ownership & Responsibility",
        "ownership-responsibility-detail":
          "Ownership & Responsibility (Detail)",
        "operation-usage": "Operation & Usage Data",
        "maintenance-compliance": "Maintenance & Compliance",
        "maintenance-compliance-detail": "Maintenance & Compliance (Detail)",
        "accessories-permits": "Accessories & Permits",
        "vehicle-usage-record": "Vehicle Usage Record",
        "fuel-management": "Fuel Management",
        "insurance-information": "Insurance Information",
        "accident-history": "Accident History",
        "driver-information": "Driver Information",
        "fleet-usage": "Fleet Usage",
        "fuel-records": "Fuel Records",
        insurance: "Insurance",
        accidents: "Accidents",
        drivers: "Drivers",
      },
      fields: {
        fleetId: "Fleet ID",
        fleetName: "Fleet Name",
        fleetType: "Fleet Type",
        status: "Status",
        vehicleId: "Vehicle ID",
        licensePlateNumber: "License Plate Number",
        vin: "Vehicle Identification Number (VIN)",
        manufacturer: "Manufacturer",
        vehicleModel: "Model",
        model: "Model",
        vehicleType: "Vehicle Type",
        vehicleCategory: "Vehicle Category",
        vehicleColor: "Vehicle Color",
        registrationDate: "Registration Date",
        serialNumber: "Serial Number",
        yearOfManufacture: "Year of Manufacture",
        dimensionLength: "Vehicle Dimensions (Length)",
        dimensionWidth: "Vehicle Dimensions (Width)",
        dimensionHeight: "Vehicle Dimensions (Height)",
        curbWeight: "Curb Weight",
        maxPayload: "Maximum Payload",
        maximumPayload: "Maximum Payload",
        vehicleDimensions: "Vehicle Dimensions",
        engineType: "Engine Type",
        engineDisplacement: "Engine Displacement",
        fuelType: "Fuel Type",
        fuelTankCapacity: "Fuel Tank Capacity",
        fuelEfficiency: "Fuel Efficiency",
        driveType: "Drive Type",
        transmission: "Transmission",
        seatCapacity: "Seat Capacity",
        responsiblePerson: "Responsible Person",
        assignedDepartment: "Assigned Department",
        vehicleUsagePurposes: "Vehicle Usage Purposes",
        assignedUserId: "Assigned User",
        assignedUser: "Assigned User",
        assignedDriverId: "Assigned Driver ID",
        ownerPurpose: "Ownership Purpose",
        usagePurpose: "Usage Purpose",
        location: "Location",
        parkingLocation: "Parking Location",
        odometerReading: "Odometer Reading",
        damageCost: "Damage Cost",
        totalOperationHours: "Total Operation Hours",
        lastOperationDate: "Last Operation Date",
        operationLog: "Operation Log",
        reservationStatus: "Reservation Status",
        utilizationRate: "Utilization Rate",
        inspectionExpiryDate: "Inspection Expiry Date",
        nextMaintenanceDate: "Next Maintenance Due",
        nextMaintenanceDue: "Next Maintenance Due",
        maintenanceDate: "Maintenance Date",
        maintenanceType: "Maintenance Type",
        maintenanceDescription: "Maintenance Description",
        maintenanceCost: "Maintenance Cost",
        maintenanceProvider: "Maintenance Provider",
        insuranceInformation: "Insurance Information",
        optionalInsuranceStatus: "Optional Insurance Status",
        maintenanceHistory: "Maintenance History",
        repairLog: "Repair Log",
        recallInfo: "Recall Information",
        roadTaxExpiryDate: "Road Tax Due Date",
        installedEquipment: "Installed Equipment",
        vehicleSensors: "Vehicle Sensors",
        gpsTrackingDevice: "GPS Tracking Device",
        dashcam: "Dash Camera",
        etcDevice: "ETC Device",
        specialPermit: "Special Permit",
        selectDriver: "Select Driver",
        usageUserId: "Driver ID",
        usageStartDate: "Start Datetime",
        usageEndDate: "End Datetime",
        usagePurposeDetail: "Purpose",
        usageDistance: "Distance Traveled",
        usageRemarks: "Usage Remarks",
        driverId: "Driver ID",
        driverName: "Used Driver Name",
        accidentDriverName: "Accident Driver Name",
        startDatetime: "Start Datetime",
        endDatetime: "End Datetime",
        startLocation: "Start Location",
        endLocation: "End Location",
        distanceTraveled: "Distance Traveled",
        fuelUsed: "Fuel Used",
        refuelDate: "Refuel Date",
        fuelAmount: "Fuel Amount",
        fuelCost: "Fuel Cost",
        fuelUnitPrice: "Unit Price",
        fuelTotalCost: "Fuel Cost",
        fuelOdometer: "Odometer",
        fuelStation: "Fuel Station",
        fuelRemarks: "Fuel Remarks",

        policyNumber: "Policy Number",
        provider: "Provider",
        coverage: "Coverage",
        startDate: "Start Date",
        endDate: "End Date",
        insuranceCompany: "Provider",
        insurancePolicyNumber: "Policy Number",
        insuranceType: "Insurance Type",
        insuranceStartDate: "Insurance Start Date",
        insuranceEndDate: "End Date",
        insurancePremium: "Insurance Premium",
        insuranceCoverage: "Coverage",
        accidentDate: "Accident Date",
        accidentLocation: "Location",
        accidentDescription: "Accident Description",
        accidentSeverity: "Accident Severity",
        accidentRepairCost: "Damage Cost",
        repairStatus: "Repair Status",
        accidentInsuranceClaim: "Insurance Claim",
        accidentReportNumber: "Report Number",
        driverUserId: "Driver ID",
        driverLicenseNumber: "License Number",
        driverLicenseType: "License Type",
        driverLicenseExpiry: "Expiration Date",
        driverAssignedDate: "Assignment Date",
        driverIsPrimary: "Primary Driver",
        licenseNumber: "License Number",
        licenseType: "License Type",
        licenseExpirationDate: "License Expiration Date",
        driverLicenseInfo: "Driver License Info",
        ownershipType: "Ownership Type",
        ownerName: "Owner Name",
        leaseCompany: "Lease Company",
        leaseContractId: "Lease Contract ID",
        placeId: "Place ID",
        gpsTrackingData: "GPS Tracking Data",
        gpsCurrentLat: "Current Latitude",
        gpsCurrentLng: "Current Longitude",
        createdAt: "Created Date",
        updatedAt: "Updated Date",
        remarks: "Remarks",
      },
    },
  },
  addSelect: {
    header: {
      headerTitle: "Select Fleet Type",
    },
    body: {
      selectFleetType: "Select the type of fleet to add",
      automobile: "Automobile",
      ship: "Ship",
      aircraft: "Aircraft",
      itemCard: {
        requiredDetails: "Required Details",
        fleetName: "Fleet Name",
        manufacturer: "Manufacturer",
        model: "Model",
        licensePlateNumber: "License Plate Number",
        registrationNumber: "Registration Number",
        shipType: "Ship Type",
        tonnage: "Tonnage",
        aircraftRegistrationNumber: "Aircraft Registration Number",
        aircraftType: "Aircraft Type",
      },
      fillOutDetails: "Fill Out Details",
    },
    options: {
      description: "Other Options",
      syncFleetManagement: "Sync with Fleet Management System",
      bulkCsvUpload: {
        title: "Bulk Upload via CSV",
      },
    },
  },
  add: {
    pageTitle: "Add Fleet",
    title: "Add Fleet",
    navigationTitles: {
      vehicle: "Vehicle Registration",
      ship: "Ship Registration",
      aircraft: "Aircraft Registration",
    },
    navigation: {
      vehicle: {
        toOwnershipResponsibility: "To Ownership & Responsibility",
        toOwnershipResponsibilityDetail:
          "To Ownership & Responsibility(Detail)",
        toMaintenanceCompliance: "To Maintenance & Compliance",
        toMaintenanceComplianceDetail: "To Maintenance & Compliance(Details)",
        toVehicleIdInformation: "to Veihicle ID Information",
        toTechnicalSpecification: "to Technical Specification",
        toOperationData: "to Operation & Usage Data",
        toAccessoriesPerm: "to Accessories & Permits",
        toVehicleUsageRecord: "to Vehicle Usage Record",
        toFuelManagement: "to Fuel Management",
        toInsuranceInformation: "to Insurance Information",
        toAccidentHistory: "to Accident History",
        toDriverInformation: "to Driver Information",
        register: "Register",
      },
      ship: {
        toOwnershipResponsibility: "To Ownership & Responsibility",
        toMaintenanceCompliance: "To Maintenance & Compliance",
        toShipIdInfo: "To Ship ID Information",
        toTechnicalSpecs: "To Technical Specifications",
        toOwnershipManagement: "To Ownership / Management",
        toOperationNav: "To Operation & Navigation",
        toMaintenanceComp: "To Maintenance / Compliance",
        toPermitsLicenses: "To Permits & Licenses",
        toAccessoriesAssets: "To Accessories & Assets",
        register: "Register",
      },
    },
    stepper: {
      basic: "Basic Info",
      identification: "Vehicle Details",
      assignment: "Insurance Info",
      placement: "Placement & Responsible",
      vehicle: "Vehicle Details",
      insurance: "Insurance",
      drivers: "Drivers",
      confirm: "Confirm",
    },
    progressbar: {
      title: "Progress",
      fieldsCompleted: "Completed",
      fieldsTotal: "Total",
      total: "All Fields",
      mustItem: "Required Fields",
      left: "{{value}} fields remaining",
      filled: "Filled",
      modeSetting: "Input Mode Setting",
      mustItemOnly: "Required Only",
    },
    sections: {
      basicInfo: "Basic Information",
      vehicleDetails: "Vehicle Details",
      shipDetails: "Ship Details",
      aircraftDetails: "Aircraft Details",
      technicalSpecs: "Technical Specifications",
      dimensions: "Dimensions & Weight",
      engineSpecs: "Engine Specifications",
      placementInfo: "Placement Information",
      insuranceInfo: "Insurance Information",
      driverInfo: "Driver Information",
    },
    fields: {
      fleetName: "Fleet Name",
      manufacturer: "Manufacturer",
      model: "Model",
      serialNumber: "Serial Number",
      yearOfManufacture: "Year of Manufacture",
      ownershipType: "Ownership Type",
      status: "Status",
      ownerPurpose: "Ownership Purpose",
      remarks: "Remarks",
      licensePlateNumber: "License Plate Number",
      vin: "VIN",
      vehicleType: "Vehicle Type",
      vehicleColor: "Vehicle Color",
      registrationDate: "Registration Date",
      engineType: "Engine Type",
      engineDisplacement: "Engine Displacement",
      fuelType: "Fuel Type",
      fuelTankCapacity: "Fuel Tank Capacity",
      fuelEfficiency: "Fuel Efficiency",
      driveType: "Drive Type",
      transmission: "Transmission",
      seatCapacity: "Seat Capacity",
      odometerReading: "Odometer Reading",
      inspectionExpiryDate: "Inspection Expiry Date",
      insurancePolicyNumber: "Insurance Policy Number",
      insuranceProvider: "Insurance Provider",
      insuranceCoverage: "Insurance Coverage",
      insuranceStartDate: "Insurance Start Date",
      insuranceEndDate: "Insurance End Date",
      insuranceAnnualPremium: "Annual Premium",
      insuranceDeductible: "Deductible",
      placeId: "Place ID",
      assignedDepartment: "Assigned Department",
      responsiblePerson: "Responsible Person",
      parkingSpotNumber: "Parking Spot Number",
      keyLocation: "Key Location",
      // Ship specific fields
      registrationNumber: "Registration Number",
      shipType: "Ship Type",
      tonnage: "Tonnage",
      homePort: "Home Port",
      callSign: "Call Sign",
      imo: "IMO Number",
      // Aircraft specific fields
      aircraftRegistrationNumber: "Aircraft Registration",
      aircraftType: "Aircraft Type",
      maximumTakeoffWeight: "Maximum Takeoff Weight",
      cruisingRange: "Cruising Range",
      passengerCapacity: "Passenger Capacity",
      engineCount: "Number of Engines",
    },
    placeholders: {
      fleetName: "e.g., Sales Vehicle 01",
      manufacturer: "e.g., Toyota",
      model: "e.g., Prius",
      serialNumber: "e.g., ABC123456",
      yearOfManufacture: "e.g., 2023",
      ownershipType: "Select ownership type",
      usagePurpose: "e.g., Sales activities",
      remarks: "Enter notes or special remarks",
      licensePlateNumber: "e.g., ABC-1234",
      vin: "e.g., JHMCM56557C404453",
      vehicleType: "e.g., Sedan",
      vehicleColor: "e.g., White",
      registrationDate: "Select date",
      engineType: "Select engine type",
      engineDisplacement: "e.g., 1800",
      fuelType: "e.g., Regular",
      fuelTankCapacity: "e.g., 50",
      fuelEfficiency: "e.g., 25.5",
      driveType: "Select drive type",
      transmission: "Select transmission",
      seatCapacity: "e.g., 5",
      odometerReading: "e.g., 12500",
      inspectionExpiryDate: "Select date",
      nextMaintenanceDate: "Select date",
      insurancePolicyNumber: "e.g., 123456789",
      insuranceProvider: "e.g., State Farm",
      insuranceCoverage: "e.g., Full coverage",
      insuranceStartDate: "Select date",
      insuranceEndDate: "Select date",
      insuranceAnnualPremium: "e.g., 1200",
      insuranceDeductible: "e.g., 500",
      placeId: "Select place",
      assignedDepartment: "e.g., Sales Department",
      responsiblePerson: "e.g., John Doe",
      parkingSpotNumber: "e.g., A-15",
      keyLocation: "e.g., Admin Office Key Box",
      // Additional vehicle registration placeholders
      fleetIdUnique: "Unique vehicle identifier",
      placeSelect: "Select location (branch office, etc.)",
      manufacturerExample: "e.g., Toyota",
      modelExample: "e.g., Prius ZVW30",
      serialNumberPlain: "Serial number",
      yearFormat: "YYYY",
      leaseContractNumber: "Lease contract number",
      leaseCompanyName: "Leasing company name",
      ownerNamePlain: "Company/Individual name",
      selectEngineType: "Select engine type",
      selectStatus: "Select status",
      selectTransmission: "Select transmission",
      selectOptionalInsurance: "Select coverage status",
      selectDriveType: "Select drive type",
      selectOwnerPurpose: "Select owner purpose",
      selectUsagePurpose: "Select usage purpose",
      selectVehicleCategory: "Select vehicle category",
      selectVehicleType: "Select vehicle type",
      selectRepairStatus: "Select repair status",
      selectOwnershipType: "Select ownership type",
      selectMaintenanceType: "Select maintenance type",
      selectFuelType: "Select fuel type",
      selectDepartment: "Select department",
      selectLicenseType: "Select license type",
      engineDisplacementCC: "cc (e.g., 1800)",
      operationHours: "Hours (for construction/special vehicles)",
      vinExample: "JH4DC4450RS123456",
      distanceKm: "km",
      fuelEfficiencyKmL: "km/L (e.g., 15.5)",
      odometerKm: "km",
      fuelCapacityL: "L",
      maintenanceIdExample: "V-2024-001",
      installedEquipmentExample: "Dashcam, navigation, ETC, etc.",
      vehicleColorWhite: "White",
      recallInfoExample: "Manufacturer recall information",
      fuelAmountLiters: "Liters (L)",
      driverIdPlain: "Driver ID",
      licenseNumberPlain: "Driver's license number",
      amountYen: "Amount",
      utilizationRatePercent: "Utilization rate (%)",
      fuelStation: "Refueling location",
      fuelCostYen: "Fuel cost",
      fuelAmountL: "Fuel amount (L)",
      repairLogExample: "Breakdown date, repair records",
      specialPermitExample: "Highway permit, heavy load permit, etc.",
      seatCapacityPeople: "Maximum passenger capacity",
      maintenanceDescriptionDetail: "Enter maintenance details",
      driverLicenseInfoExample: "License type, expiration date",
      usagePurposePlain: "Usage purpose",
      accidentDescriptionDetail: "Accident details",
      accidentLocationPlain: "Accident location",
      vehicleWeightKg: "Vehicle weight (kg)",
      employeeIdDriver: "Employee ID (assignable as driver)",
      driverNamePlaceholder: "Driver name or Employee Number",
      shipNameExample: "e.g., Ocean Star",
      shipFleetIdPlaceholder: "Unique vessel identifier",
      selectHomePort: "Select home port",
      shipManufacturerExample: "e.g., Mitsubishi Heavy Industries",
      shipModelExample: "e.g., Container Ship 2000",
      shipSerialNumber: "Hull number",
      yearPlaceholder: "YYYY",
      selectShipType: "Please select",
      builderNameExample: "Shipyard name (e.g., Mitsubishi Heavy Industries)",
      grossTonnagePlaceholder: "Gross tonnage",
      deadweightCapacity: "Payload capacity",
      selectNavigationArea: "Please select",
      selectPropulsionType: "Please select",
      managementCompanyName: "Operation management company name",
      operationDepartmentExample: "e.g., Sales Department, Shipping Department",
      homePortExample: "Port name (e.g., Yokohama Port)",
      voyageLogExample: "Departure port, arrival port, voyage time, etc.",
      hoursUnit: "Hours (h)",
      nauticalMilesUnit: "Nautical miles (NM)",
      aisDataExample: "Automatic Identification System data",
      inspectionLogExample: "Periodic inspection, special inspection history",
      maintenanceLogExample: "Repair and dry-dock records",
      insuranceInfoExample: "Insurance company, policy number, expiry date",
      accidentLogExample: "Accident date, details, and response",
      specialNavigationPermitExample: "Dangerous goods loading permit, etc.",
      emissionCertificatesExample: "EEDI, SEEMP related",
      firefightingEquipmentExample:
        "e.g., 20 fire extinguishers, 10 fire hoses",
      electronicDevicesExample: "e.g., GPS, radar, fish finder",
      operationLogExample: "Departure/return time, mileage, driver, etc.",
      departureLocation: "Departure location",
      vehicleSensorsExample: "Collision prevention, backup camera, etc.",
      maintenanceProviderExample:
        "Service company or internal maintenance staff",
      maxPayloadKg: "Load capacity (kg)",
      dimensionsExample: "L×W×H (mm) e.g., 4500×1800×1500",
      damageAmountYen: "Damage amount",
      maintenanceHistoryExample:
        "Date, maintenance details, service shop, etc.",
      licensePlateExample: "ABC 500 A 12-34",
      responsiblePersonExample: "Department manager or IT administrator",
      insuranceCompanyNamePlain: "Insurance company name",
      insurancePolicyNumberPlain: "Insurance policy number",
      insuranceCoveragePlain: "Insurance coverage",
      destinationLocation: "Destination",
      tokyoOfficeBranchExample: "e.g., Tokyo HQ, Osaka Branch",
      // Ship specific placeholders
      registrationNumber: "e.g., JPN-123456",
      shipType: "e.g., Cargo Ship",
      tonnage: "e.g., 5000",
      homePort: "e.g., Tokyo Port",
      callSign: "e.g., JA1234",
      imo: "e.g., 1234567",
      // Aircraft specific placeholders
      aircraftRegistrationNumber: "e.g., JA8089",
      aircraftType: "e.g., Boeing 737",
      maximumTakeoffWeight: "e.g., 79000",
      cruisingRange: "e.g., 5000",
      passengerCapacity: "e.g., 189",
      engineCount: "e.g., 2",
    },
    ownershipType: {
      owned: "Company Owned",
      leased: "Leased",
      rented: "Rented",
    },
    status: {
      available: "Available",
      inUse: "In Use",
      maintenance: "Under Maintenance",
      retired: "Retired",
      disposed: "Disposed",
    },
    engineType: {
      gasoline: "Gasoline",
      diesel: "Diesel",
      electric: "Electric",
      hybrid: "Hybrid",
      phev: "Plug-in Hybrid",
      hydrogen: "Hydrogen",
    },
    engineTypes: {
      GASOLINE: "Gasoline",
      DIESEL: "Diesel",
      ELECTRIC: "Electric",
      HYBRID: "Hybrid",
      PLUGIN_HYBRID: "Plug-in Hybrid",
      HYDROGEN: "Hydrogen",
    },
    driveType: {
      twoWd: "2WD",
      fourWd: "4WD",
      awd: "AWD",
    },
    optionalInsuranceStatus: {
      insured: "Insured",
      not_insured: "Not Insured",
      processing: "Processing",
    },
    licenseTypes: {
      ordinary: "Ordinary",
      medium: "Medium",
      large: "Large",
    },
    ownershipPurposes: {
      COMMERCIAL_TRANSPORT: "Commercial Transport",
      PASSENGER_SERVICE: "Passenger Service",
      CARGO_TRANSPORT: "Cargo Transport",
      INVESTIGATION: "Investigation",
      TRAINING: "Training",
      EXECUTIVE: "Executive",
      SALES: "Sales",
      LOGISTICS: "Logistics",
    },
    transmission: {
      at: "AT",
      mt: "MT",
      cvt: "CVT",
      dct: "DCT",
    },
    fleetStatus: {
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      MAINTENANCE: "Under Maintenance",
      DECOMMISSIONED: "Decommissioned",
      DISPOSED: "Disposed",
    },
    shipTypes: {
      CONTAINER: "Container ship",
      TANKER: "Tanker",
      BULK_CARRIER: "Bulk carrier",
      RORO: "Roll-on/Roll-off ship",
      FERRY: "Ferry",
      PASSENGER: "Passenger ship",
      CRUISE: "Cruise ship",
      TUG: "Tug boat",
      BARGE: "Barge",
      FISHING: "Fishing vessel",
      RESEARCH: "Research vessel",
      PATROL: "Patrol boat",
      WORK_BOAT: "Work boat",
      YACHT: "Yacht",
    },
    maintenanceTypes: {
      PREVENTIVE: "Preventive Maintenance",
      CORRECTIVE: "Corrective Maintenance",
      INSPECTION: "Inspection",
      OVERHAUL: "Overhaul",
      EMERGENCY: "Emergency",
    },
    ownershipTypes: {
      OWNED: "Owned",
      LEASED: "Leased",
      CHARTERED: "Chartered",
      RENTAL: "Rental",
      CAR_SHARE: "Car Share",
      OPERATIONAL_LEASE: "Operational Lease",
      FINANCE_LEASE: "Finance Lease",
      OTHER: "Other",
    },
    buttons: {
      next: "Next",
      back: "Back",
      save: "Save",
      saveDraft: "Save as Draft",
      cancel: "Cancel",
    },
    validation: {
      required: "This field is required",
      invalidFormat: "Invalid format",
      duplicateFleetId: "This Fleet ID is already in use",
      duplicateLicensePlate: "This license plate is already registered",
      duplicateVin: "This VIN is already registered",
    },
    reservationStatuses: {
      AVAILABLE: "Available",
      RESERVED: "Reserved",
      IN_USE: "In Use",
      MAINTENANCE: "Maintenance",
      CLEANING: "Cleaning",
      INSPECTION: "Inspection",
      NOT_AVAILABLE: "Not Available",
      STORED: "Stored",
    },
  },
  settings: {
    title: "Fleet Settings",
    tabs: {
      types: "Fleet Types",
      categories: "Fleet Categories",
    },
    fleetTypes: {
      title: "Fleet Types",
      addButton: "Add Type",
      table: {
        name: "Type Name",
        description: "Description",
        isEnabled: "Enabled",
        actions: "Actions",
      },
    },
    fleetCategories: {
      title: "Fleet Categories",
      addButton: "Add Category",
      table: {
        name: "Category Name",
        type: "Type",
        description: "Description",
        isEnabled: "Enabled",
        actions: "Actions",
      },
    },
    dialog: {
      addTitle: "Add",
      editTitle: "Edit",
      deleteTitle: "Delete Confirmation",
      deleteMessage:
        "Are you sure you want to delete? This action cannot be undone.",
      enableTitle: "Enable",
      enableMessage: "Do you want to enable?",
      disableTitle: "Disable",
      disableMessage: "Do you want to disable?",
    },
  },
  actions: {
    edit: "Edit",
    delete: "Delete",
    updateStatus: "Update Status",
    addMaintenance: "Add Maintenance Record",
    addUsage: "Add Usage Record",
    export: "Export",
    print: "Print",
    viewDetails: "View Details",
  },
  messages: {
    createSuccess: "Fleet created successfully",
    updateSuccess: "Fleet updated successfully",
    deleteSuccess: "Fleet deleted successfully",
    statusUpdateSuccess: "Status updated successfully",
    maintenanceAddSuccess: "Maintenance record added successfully",
    usageAddSuccess: "Usage record added successfully",
    error: "An error occurred",
  },
};
